import type { Usuario } from "@/types/usuario";
import axios from "axios";
import type { Ref } from "vue";
import { ref } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";

export default function useUsuario() {
    const store = useStore(key);
    let lstUsuarios: Ref<Usuario[]> = ref([]);
    let usuario: Ref<Usuario | null> = ref(null);

    async function getUsuarios() {
        try {
            await axios
                .get(store.state.url + "api/Usuario/GetUsuarios", {
                    headers: {},
                })
                .then((response) => {
                    if (response.status == 200) {
                        lstUsuarios.value = response.data as Usuario[];
                        // console.log(JSON.stringify(lstUsuarios.value));
                    } else {
                        console.log(response.statusText);
                    }
                })
                .catch(function (error) {
                    console.log(error.message);
                });
        } catch (error) {
            console.log(error);
        }
    }

    async function getUsuarioByEmail(email: string) {
        try {
            await axios
                .get(store.state.url + `api/Usuario/GetUsuarioByEmail?email=${email}`, {
                    headers: {},
                })
                .then((response) => {
                    if (response.status == 200) {
                        usuario.value = response.data as Usuario;
                    } else {
                        console.log(response.statusText);
                        usuario.value = null;
                    }
                })
                .catch(function (error) {
                    console.log(error.message);
                    usuario.value = null;
                });
        } catch (error) {
            console.log(error);
            usuario.value = null;
        }
    }

    async function postUsuario(usuarioData: Usuario): Promise<boolean | null> {
        try {
            const response = await axios.post(store.state.url + "api/Usuario/PostUsuario", usuarioData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.status == 200 || response.status == 201) {
                return true;
            } else {
                console.log(response.statusText);
                return false;
            }
        } catch (error: any) {
            console.log(error?.message ?? error);
            return null;
        }
    }

    async function updateUsuario(usuarioData: Usuario) {
        try {
            await axios
                .put(store.state.url + "api/Usuario/UpdateUsuario", usuarioData, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    if (response.status == 200) {
                        return response.data;
                    } else {
                        console.log(response.statusText);
                        return null;
                    }
                })
                .catch(function (error) {
                    console.log(error.message);
                    return null;
                });
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async function deleteUsuario(id: number) {
        try {
            await axios
                .delete(store.state.url + `api/Usuario/DeleteUsuario?id=${id}`, {
                    headers: {},
                })
                .then((response) => {
                    if (response.status == 200 || response.status == 204) {
                        return true;
                    } else {
                        console.log(response.statusText);
                        return false;
                    }
                })
                .catch(function (error) {
                    console.log(error.message);
                    return false;
                });
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    async function existeUsuarioEmail(email: string): Promise<boolean | null> {
        try {
            const response = await axios.get(store.state.url + `api/Usuario/ExisteUsuarioEmail?email=${email}`, {
                headers: {},
            });
            if (response.status == 200) {
                return response.data as boolean;
            } else {
                console.log(response.statusText);
                return false;
            }
        } catch (error: any) {
            console.log(error?.message ?? error);
            return null;
        }
    }

    return { getUsuarios, getUsuarioByEmail, postUsuario, updateUsuario, deleteUsuario, existeUsuarioEmail, lstUsuarios, usuario };
}
